module.exports = __webpack_public_path__ + "static/media/hotelPageTrainingIcon.1ffece62.png";